import { render, staticRenderFns } from "./AdminSuppliers.vue?vue&type=template&id=0dafd42e&scoped=true&"
import script from "./AdminSuppliers.vue?vue&type=script&lang=js&"
export * from "./AdminSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dafd42e",
  null
  
)

export default component.exports